import type { InsightCard } from '@/lib/insights'

interface Props {
  cards: InsightCard[]
}

const SEVERITY_STYLES: Record<InsightCard['severity'], { border: string; chip: string; chipBg: string }> = {
  good: { border: 'border-secondary/30', chip: 'text-secondary', chipBg: 'bg-secondary/10' },
  warn: { border: 'border-error/30',     chip: 'text-error',     chipBg: 'bg-error/10' },
  info: { border: 'border-primary/30',   chip: 'text-primary',   chipBg: 'bg-primary/10' },
}

export function InsightsPanel({ cards }: Props) {
  if (cards.length === 0) return null
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-6 sm:mb-10">
      {cards.map((card) => {
        const styles = SEVERITY_STYLES[card.severity]
        return (
          <div key={card.id} className={`rounded-xl border ${styles.border} bg-surface-container p-4 sm:p-5`}>
            <div className="flex items-center gap-2 mb-2">
              <span className={`text-[10px] font-mono uppercase tracking-widest px-1.5 py-0.5 rounded ${styles.chip} ${styles.chipBg}`}>
                {card.severity === 'warn' ? 'Watch' : card.severity === 'good' ? 'Good' : 'Info'}
              </span>
            </div>
            <p className="text-sm font-semibold text-white mb-1.5">{card.title}</p>
            <p className="text-xs text-on-surface-variant leading-relaxed">{card.body}</p>
          </div>
        )
      })}
    </div>
  )
}
